module.exports = __webpack_public_path__ + "static/media/gallery_2_3.52c939ab.jpg";